import React from 'react';
import DataGrid, { Column, SearchPanel, Export, StateStoring, ColumnChooser, ColumnFixing, Scrolling, HeaderFilter, FilterRow, FilterPanel, Summary, TotalItem, Toolbar, Item as ToolbarItem } from 'devextreme-react/data-grid';
// import { Form, Item as FormItem, SimpleItem, GroupItem, RequiredRule, RangeRule, Label as FormLabel, ValidationRule } from 'devextreme-react/form';
import { Template } from 'devextreme-react/core/template';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { withSnackbar } from 'notistack';
import ExcelJS from 'exceljs';
import Common from '../../shared/common';
import saveAs from 'file-saver';
import { Link } from "react-router-dom";
import { withRouter } from '../../shared/hoc/withRouter';
import moment from 'moment';
import sanitizeHtml from 'sanitize-html-react';
import NavigationBlocker from '../Tools/NavigationBlocker';
import { FormattedMessage, injectIntl } from "react-intl";
import { htmlSenitizeOptions } from '../../shared/config/DxFormProperties';
import { connect } from "react-redux";
import { Popover } from 'devextreme-react/popover';
import { PropTypes } from "prop-types";
import { custom as CustomDialog } from 'devextreme/ui/dialog';
import { listAccountsAllowedRegisterBatchOperations, listAccountsAllowedRegisterBatchOperationsWhenEnabled } from '../../router/Protector/AccessExceptions';
import { forEach } from 'lodash';
import MigrationHelper from "../../shared/migrationHelper";
import SystemHelper from "../../shared/systemHelper";
import { GetEvaluatedUserFilters } from "../../Templates/TemplateAdjust";
// import { Popup, ToolbarItem as PopupToolbarItem } from 'devextreme-react/popup';
import DataGridBaseBatchComModal from './DataGridBaseBatchComModal';


const batchCommunicateMaxCount = 200;
const amountHeaderFilter = JSON.stringify([{
    text: 'Less than 1,000',
    value: ['Amount', '<', 1000]
}, {
    text: '1,000 - 5,000',
    value: [
        ['Amount', '>=', 1000],
        ['Amount', '<', 5000]
    ]
}, {
    text: '5,000 - 10,000',
    value: [
        ['Amount', '>=', 5000],
        ['Amount', '<', 10000]
    ]
}, {
    text: '10,000 - 25,000',
    value: [
        ['Amount', '>=', 10000],
        ['Amount', '<', 25000]
    ]
}, {
    text: '25,000 - 100,000',
    value: [
        ['Amount', '>=', 25000],
        ['Amount', '<', 100000]
    ]
}, {
    text: 'Greater than 100,000',
    value: ['Amount', '>=', 100000]
}]);

const contractAmountHeaderFilter = JSON.stringify([{
    text: 'Less than 5,000',
    value: ['Amount', '<', 5000]
}, {
    text: '5,000 - 50,000',
    value: [
        ['Amount', '>=', 5000],
        ['Amount', '<', 50000]
    ]
}, {
    text: '50,000 - 250,000',
    value: [
        ['Amount', '>=', 50000],
        ['Amount', '<', 250000]
    ]
}, {
    text: '250,000 - 1,000,000',
    value: [
        ['Amount', '>=', 250000],
        ['Amount', '<', 1000000]
    ]
}, {
    text: '1,000,000 - 5,000,000',
    value: [
        ['Amount', '>=', 1000000],
        ['Amount', '<', 5000000]
    ]
}, {
    text: '5,000,000 - 25,000,000',
    value: [
        ['Amount', '>=', 5000000],
        ['Amount', '<', 25000000]
    ]
}, {
    text: 'Greater than 25,000,000',
    value: ['Amount', '>=', 25000000]
}]);


class DataGridBase extends React.Component {
    constructor(props) {
        super(props);
        this.gridRef = props.gridRef ? props.gridRef : React.createRef();
        this.fileImportInputRef = React.createRef();
        this.batchCommunicateFormRef = React.createRef();
        let referenceIDPrefix = props.referenceIDPrefix;
        if (!referenceIDPrefix && props.workflowItem) {
            referenceIDPrefix = props.workflowItem?.abbreviation;
        }
        this.minIDColumnWidth = Math.round(Common.getTextWidth(referenceIDPrefix + '10000', "bold 14pt Helvetica Neue"));

        this.batchOperationsEnabled = false;
        if (process.env.REACT_APP_BATCH_OPERATIONS_ENABLED === "true" && !!this.props.batchOperations) {
            //REGISTER SUPPORTS BATCH OPERATION
            if (listAccountsAllowedRegisterBatchOperations.includes(this.props.userProfile.accounttype)) {
                this.batchOperationsEnabled = true;
            }
            else if (listAccountsAllowedRegisterBatchOperationsWhenEnabled.includes(this.props.userProfile.accounttype)) {
                this.batchOperationsEnabled = process.env.REACT_APP_REGISTER_BATCH_OPERATIONS_ENABLED === "true";
            }
        }


        this.toolbarButtonRefs = [];
        this.toolbarBatchButtonRefs = [];
        this.additionalToolbarItems = (this.props.additionalToolbarItems || []).map(itm => ({
            ...itm,
            options: {
                ...itm.options,
                onInitialized: (e) => { this.toolbarButtonRefs.push(e) }
            }
        }))

        this.localStorageKey = this.generateUniqueGridName();
        const noDataText = this.props.intl.formatMessage({ id: "GENERAL.WORDS.NONE_PREFIX" }) + ' ' + this.props.name;

        const defaultProps = {
            showBorders: true,
            showColumnLines: true,
            showRowLines: true,
            remoteOperations: false,
            allowColumnReordering: true,
            columnAutoWidth: true,
            // rowAlternationEnabled: true,
            allowColumnResizing: true,
            columnResizingMode: window.innerWidth <= 1024 ? 'nextColumn' : 'widget',
            columnHidingEnabled: window.innerWidth <= 1024 ? true : false,
            wordWrapEnabled: true,
            cellHintEnabled : true,
            noDataText: noDataText,
            onExporting: this.onExporting,
            onRowPrepared: this.onRowPrepared
        }


        this.columns = this.props.columns.map((columnItem, index) => {
            const itmProps = { headerFilter: {}, ...columnItem }; ///, headerCellRender: this.headerCellRender
            if (itmProps.resource) {
                itmProps.caption = this.props.intl.formatMessage({ id: itmProps.resource })
            }
            if (itmProps.dataType && itmProps.dataType === 'date' && !itmProps.format) {
                //https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
                //itmProps.format = { year: "numeric", month: "2-digit", day: "2-digit" };
                itmProps.format = (date) => moment(date).format('L');
            }
            if (itmProps.dataType && itmProps.dataType === 'datetime' && !itmProps.format) {
                //https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
                //itmProps.format = { year: "numeric", month: "2-digit", day: "2-digit" };
                itmProps.format = (date) => moment(date).format('DD/MM/YYYY HH:mm');
            }
            if (itmProps.dataType && itmProps.dataType === 'currency') {
                //https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/NumberFormat#Parameters
                //itmProps.format = { type: "currency", precision: 2, currency: "GBP" };
                itmProps.format = (num) => Common.FormatCurrencyNum(num, itmProps.currencyCode);
                itmProps.headerFilter.dataSource = this.props.isContract
                    ? JSON.parse(
                        contractAmountHeaderFilter.replace(
                            new RegExp("Amount", "g"),
                            itmProps.dataField
                        )
                    )
                    : JSON.parse(
                        amountHeaderFilter.replace(
                            new RegExp("Amount", "g"),
                            itmProps.dataField
                        )
                    );
            }
            if (itmProps.dataType === "tag") {
                if (!itmProps.calculateCellValue) {
                    itmProps.calculateCellValue = this.calculateTagValue.bind(this, itmProps.dataField);
                }
                itmProps.calculateFilterExpression = (filterValue, selectedFilterOperation, target) => {
                    if (target === "headerFilter") {
                        if (selectedFilterOperation === "=" && filterValue === null) {
                            return [itmProps.dataField, "=", null];
                        }
                        else {
                            const filterExpression = [
                                [itmProps.dataField, "=", filterValue],
                                "or",
                                [itmProps.dataField, "startswith", filterValue + ","],
                                "or",
                                [itmProps.dataField, "contains", ", " + filterValue + ","],
                                "or",
                                [itmProps.dataField, "endswith", ", " + filterValue]
                            ];

                            return filterExpression;
                        }

                    }
                    return [itmProps.dataField, "contains", filterValue];
                }
            }
            if (itmProps.isHtml === true) {
                //https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/NumberFormat#Parameters
                //itmProps.format = { type: "currency", precision: 2, currency: "GBP" };
                // if (!itmProps.cellRender) {
                //     itmProps.cellRender = this.renderHtmlCell.bind(this, itmProps.dataField);
                // }
                if (!itmProps.calculateCellValue) {
                    itmProps.calculateCellValue = this.calculateHtmlValue.bind(this, itmProps.dataField);
                }
                if (!itmProps.hasOwnProperty('visible')) {
                    itmProps.visible = false;
                }
                // if (!itmProps.hasOwnProperty('allowFiltering')) {
                //     itmProps.allowFiltering = false;
                // }
            }
            if (this.props.onSelectionChanged) {
                if (index === 0) {
                    itmProps.cssClass = "WrappedIdColumnWithPointer";
                    if (!itmProps.skipAutoReference) {
                        itmProps.minWidth = this.minIDColumnWidth;
                        // if (!itmProps.calculateSortValue && itmProps.dataField === "referenceid") {
                        //     //WF REGISTER
                        //     // itmProps.calculateCellValue = this.calculateIdCellValue;
                        //     itmProps.calculateSortValue = this.sortIdColumn;
                        // }
                        if (itmProps.renderReferenceidLink) {
                            itmProps.cellRender = this.renderIdColumn;
                            itmProps.width = 200;
                            itmProps.maxWidth = 200;
                            itmProps.minWidth = 200;
                            itmProps.allowHiding = false;
                            itmProps.allowReordering = false;
                            itmProps.allowFixing = false;  
                            itmProps.allowResizing = false;
                        }
                    }
                }
                else if (!itmProps.cssClass) {
                    itmProps.cssClass = "WrappedColumnWithPointer";
                }
            }
            else{
                if (!itmProps.cssClass) {
                    itmProps.cssClass = "WrappedColumn";
                }
            }
            return itmProps;
        });

        this.dataGridProps = { ...defaultProps, ...this.props, style: { width: '100%', height: '100%', maxHeight: '67vh', ...this.props.style } };
        delete this.dataGridProps.columns;
        delete this.dataGridProps.name;

        this.formFields = [];
        if (this.props.batchOperations && props.batchFormFields) {
            const { formFields, unsupportedCustomFieldWarning } = MigrationHelper.getFormFieldsConfig(props.batchFormFields, props.workflowItem, props.customFields);
            this.formFields = formFields;
            this.batchUnsupportedCustomFieldWarning = unsupportedCustomFieldWarning;
        }

        this.state = {
            batchEditing: false,
            showCommunicateModal: false,
        };

    }
    componentDidMount() {
        if (this.gridRef && this.gridRef.current && this.gridRef.current.instance && this.props.repaintAfterMounted) {
            //this.gridRef.instance().clearFilter('search');

            this.timer = setTimeout(() => {
                // this.gridRef.instance().pageIndex(0);
                this.gridRef.current.instance().repaint();
                // this.gridRef.instance().updateDimensions();
            }, 300);
        }

    }
    shouldComponentUpdate(nextProps, nextState) {
        if (this.props.dataSource !== nextProps.dataSource) {
            return true;
        }
        if (this.state.batchEditing !== nextState.batchEditing) {
            return true;
        }
        if (this.state.showCommunicateModal !== nextState.showCommunicateModal) {
            return true;
        }
        if (this.state.isBusy !== nextState.isBusy) {
            return true;
        }
        // console.log("Re-render blocked")
        return false;
    }
    componentWillUnmount() {
        clearTimeout(this.timer);
        if (this.props.closeSnackbar) {
            this.props.closeSnackbar();
        }
    }
    // headerCellRender = cellInfo => {
    //     return (
    //         <h5 style={{ color: "black" }} className="kt-subheader__title">{cellInfo.column.caption}</h5>
    //     )
    // }
    onExporting = (e) => {
        e.component.beginUpdate();
        const hiddenColumns = [];
        this.props.columns.forEach(column => {
            const isVisible = e.component.columnOption(column.dataField, "visible");
            if (!isVisible) {
                hiddenColumns.push(column.dataField);
            }
        });

        hiddenColumns.forEach(columnField => {
            e.component.columnOption(columnField, "visible", true);
        });
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Main sheet');
        const fileName = this.props.name;

        exportDataGrid({
            component: e.component,
            worksheet: worksheet,
            autoFilterEnabled: true,
            customizeCell: (options) => {
                const { gridCell, excelCell } = options;
                if (gridCell.rowType === 'data') {
                    if (typeof gridCell.value === 'number' && Math.abs(gridCell.value) > 999999999) {

                        excelCell.numFmt = '#,##0';
                    }
                    if (gridCell.column.dataField === 'url') {
                        // https://github.com/exceljs/exceljs#hyperlink-value
                        excelCell.value = { text: 'Link', hyperlink: gridCell.value };
                        // https://github.com/exceljs/exceljs#fonts
                        excelCell.font = { color: { argb: 'FF0000FF' }, underline: true };
                        // https://github.com/exceljs/exceljs#alignment
                        excelCell.alignment = { horizontal: 'left', vertical: 'top' };
                    }
                }
            }
        }).then(() => {
            // https://github.com/exceljs/exceljs#writing-xlsx
            workbook.xlsx.writeBuffer().then(function (buffer) {
                saveAs(new Blob([buffer], { type: 'application/octet-stream' }), fileName + '.xlsx');
            });
        }).then(function () {
            hiddenColumns.forEach(columnField => {
                e.component.columnOption(columnField, "visible", false);
            });
            e.component.endUpdate();
        });

        e.cancel = true;
    }

    deleteSelectedClick = async () => {
        const selection = this.gridRef.current.instance().getSelectedRowKeys();
        if (selection.length) {
            //ACCESS VALIDATION CHECKS
            const selectedItems = this.gridRef.current.instance().getSelectedRowsData();
            const invalidItem = selectedItems.find(a => (!this.validateDelete(a).allowed));
            if (invalidItem) {
                this.props.enqueueSnackbar(this.validateDelete(invalidItem).error, { variant: "error" });
                return;
            }

            let activateDialog = CustomDialog({
                title: this.props.intl.formatMessage({ id: 'BATCH_OPS.POPUP.DELETE.TITLE' }, { COUNT: selection.length }),
                messageHtml: `<div style="max-width:60vw;">${this.props.intl.formatMessage({ id: 'BATCH_OPS.POPUP.DELETE.MESSAGE' }, { COUNT: selection.length })}</div>`,
                buttons: [
                    {
                        text: this.props.intl.formatMessage({ id: "GENERAL.FORMS.BUTTON_CANCEL" }),
                        onClick: (e) => { return "CANCEL" }
                    },
                    {
                        text: this.props.intl.formatMessage({ id: "GENERAL.FORMS.BUTTON_DELETE" }),
                        type: "danger",
                        stylingMode: "outlined",
                        onClick: (e) => { return "CONTINUE" }
                    }
                ]
            });
            const result = await activateDialog.show();
            if (result === "CONTINUE") {
                const formData = {
                    data: selection,
                    contractid: this.props.contract.contractid
                };
                this.props.closeSnackbar();
                this.setState({ isBusy: true }, async () => {
                    try {
                        this.gridRef.current.instance().beginCustomLoading("Deleting records...");
                        const { data: itemCount } = await this.props.batchDeleteEndpoint(formData)
                        this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: "BATCH_OPS.TOAST.DRAFTS_DELETED" }), { variant: "success" });
                        this.gridRef.current.instance().clearSelection();
                        this.props.onBatchRecordsUpdated?.();
                    }
                    catch (err) {
                        console.log(err);
                        this.props.enqueueSnackbar(err.toString(), { variant: "error" });
                    }
                    finally {
                        this.setState({ isBusy: false })
                        this.gridRef.current.instance().endCustomLoading();
                    }
                })

            }
        }


    }
    deactivateSelectedClick = async () => {
        const selection = this.gridRef.current.instance().getSelectedRowKeys();
        if (selection.length) {
            //ACCESS VALIDATION CHECKS
            const selectedItems = this.gridRef.current.instance().getSelectedRowsData();
            const invalidItem = selectedItems.find(a => (!this.validateDeactivate(a).allowed));
            if (invalidItem) {
                this.props.enqueueSnackbar(this.validateDeactivate(invalidItem).error, { variant: "error" });
                return;
            }

            let activateDialog = CustomDialog({
                title: this.props.intl.formatMessage({ id: 'BATCH_OPS.POPUP.DEACTIVATE.TITLE' }, { COUNT: selection.length }),
                messageHtml: `<div style="max-width:60vw;">${this.props.intl.formatMessage({ id: 'BATCH_OPS.POPUP.DEACTIVATE.MESSAGE' }, { COUNT: selection.length })}</div>`,
                buttons: [
                    {
                        text: this.props.intl.formatMessage({ id: "GENERAL.FORMS.BUTTON_CANCEL" }),
                        onClick: (e) => { return "CANCEL" }
                    },
                    {
                        text: this.props.intl.formatMessage({ id: "GENERAL.FORMS.BUTTON_DEACTIVATE" }),
                        type: "warning",
                        stylingMode: "outlined",
                        elementAttr: { class: "biWarningButton" },
                        onClick: (e) => { return "CONTINUE" }
                    }
                ]
            });
            const result = await activateDialog.show();
            if (result === "CONTINUE") {
                const formData = {
                    data: selection,
                    contractid: this.props.contract.contractid
                };
                this.props.closeSnackbar();
                this.setState({ isBusy: true }, async () => {
                    try {
                        this.gridRef.current.instance().beginCustomLoading("Deactivating records...");
                        const { data: itemCount } = await this.props.batchDeactivateEndpoint(formData)
                        this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: "BATCH_OPS.TOAST.DEACTIVATED" }, { COUNT: itemCount }), { variant: "warning" });
                        this.gridRef.current.instance().clearSelection();
                        this.props.onBatchRecordsUpdated?.();
                    }
                    catch (err) {
                        console.log(err);
                        this.props.enqueueSnackbar(err.toString(), { variant: "error" });
                    }
                    finally {
                        this.setState({ isBusy: false })
                        this.gridRef.current.instance().endCustomLoading();
                    }
                })

            }
        }


    }
    activateSelectedClick = async () => {
        const selection = this.gridRef.current.instance().getSelectedRowKeys();
        if (selection.length) {
            //ACCESS VALIDATION CHECKS
            const selectedItems = this.gridRef.current.instance().getSelectedRowsData();
            const invalidItem = selectedItems.find(a => (!this.validateActivate(a).allowed));
            if (invalidItem) {
                this.props.enqueueSnackbar(this.validateActivate(invalidItem).error, { variant: "error" });
                return;
            }

            let activateDialog = CustomDialog({
                title: this.props.intl.formatMessage({ id: 'BATCH_OPS.POPUP.ACTIVATE.TITLE' }, { COUNT: selection.length }),
                messageHtml: `<div style="max-width:60vw;">${this.props.intl.formatMessage({ id: 'BATCH_OPS.POPUP.ACTIVATE.MESSAGE' }, { COUNT: selection.length })}</div>`,
                buttons: [
                    {
                        text: this.props.intl.formatMessage({ id: "GENERAL.FORMS.BUTTON_CANCEL" }),
                        onClick: (e) => { return "CANCEL" }
                    },
                    {
                        text: this.props.intl.formatMessage({ id: "GENERAL.FORMS.BUTTON_ACTIVATE" }),
                        type: "success",
                        stylingMode: "outlined",
                        onClick: (e) => { return "CONTINUE" }
                    }
                ]
            });
            const result = await activateDialog.show();
            if (result === "CONTINUE") {
                const formData = {
                    data: selection,
                    contractid: this.props.contract.contractid
                };
                this.props.closeSnackbar();
                this.setState({ isBusy: true }, async () => {
                    try {
                        this.gridRef.current.instance().beginCustomLoading("Activating records...");
                        const { data: itemCount } = await this.props.batchActivateEndpoint(formData)
                        this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: "BATCH_OPS.TOAST.ACTIVATED" }, { COUNT: itemCount }), { variant: "warning" });
                        this.gridRef.current.instance().clearSelection();
                        this.props.onBatchRecordsUpdated?.();
                    }
                    catch (err) {
                        console.log(err);
                        this.props.enqueueSnackbar(err.toString(), { variant: "error" });
                    }
                    finally {
                        this.setState({ isBusy: false })
                        this.gridRef.current.instance().endCustomLoading();
                    }
                })

            }
        }


    }
    batchCommunicateSelectedClick = async () => {
        const selection = this.gridRef.current.instance().getSelectedRowKeys();
        if (selection.length) {
            //ACCESS VALIDATION CHECKS
            const selectedItems = this.gridRef.current.instance().getSelectedRowsData();
            const invalidItem = selectedItems.find(a => (!this.validateCommunicate(a).allowed));
            if (invalidItem) {
                this.props.enqueueSnackbar(this.validateCommunicate(invalidItem).error, { variant: "error" });
                return;
            }

            this.setState({ showCommunicateModal: true });
        }
    }
    batchCommunicatApprovedClick = async (communicateUserAccountID) => {

        const selection = this.gridRef.current.instance().getSelectedRowKeys();
        const formData = {
            data: selection,
            contractid: this.props.contract.contractid,
            communicateuseraccountid: communicateUserAccountID,
            workflowid: this.props.workflowItem?.id
        };
        this.props.closeSnackbar();
        this.setState({ isBusy: true }, async () => {
            try {
                this.gridRef.current.instance().beginCustomLoading("Communicating records...");
                const { data: batchResult } = await this.props.batchCommunicateEndpoint(formData)

                if (batchResult.successfulrecordcount > 0) {
                    this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: 'BATCH_OPS.TOAST.DRAFTS_COMMUNICATED' }, { COUNT: batchResult.successfulrecordcount }), { variant: 'success', });
                }
                if (batchResult.error) {
                    console.log(batchResult.error)
                    this.props.enqueueSnackbar(batchResult.error, { variant: 'error', persist: true });
                }

                if (batchResult.successfulrecordcount === 0 && !batchResult.error) {
                    //NO IMPORT & NO ERROR
                    this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: 'ACTIONS.TOAST.IMPORTED_NONE' }), { variant: 'warning', });
                }



                this.gridRef.current.instance().clearSelection();
                this.props.onBatchRecordsUpdated?.();

            }
            catch (err) {
                console.log(err);
                this.props.enqueueSnackbar(err.toString(), { variant: "error", persist: true });
            }
            finally {
                this.setState({ isBusy: false, showCommunicateModal: false });
                this.gridRef.current.instance().endCustomLoading();
            }
        })
    }
    validateCommunicate = (notificationItem) => {
        let allowed = true;
        let error = "";
        // if (notificationItem.deleted !== 0) {
        //     allowed = false;
        //     error = this.props.intl.formatMessage({ id: "BATCH_OPS.ERRORS.RECORD_DELETED" });
        // }
        // else 
        if (notificationItem.showtasknotification && notificationItem.showtasknotification !== 0) {
            allowed = false;
            error = (notificationItem.referenceid || "") + " " + this.props.intl.formatMessage({ id: "BATCH_OPS.ERRORS.RECORD_NOT_DRAFT" });
        } else if (notificationItem.communicated) {
            allowed = false;
            error = (notificationItem.referenceid || "") + " " + this.props.intl.formatMessage({ id: "BATCH_OPS.ERRORS.RECORD_NOT_DRAFT" });
        }
        return { allowed, error }
    }
    validateDelete = (notificationItem) => {
        let allowed = true;
        let error = "";
        // if (notificationItem.deleted !== 0) {
        //     allowed = false;
        //     error = this.props.intl.formatMessage({ id: "BATCH_OPS.ERRORS.RECORD_DELETED" });
        // }
        // else 
        if (notificationItem.showtasknotification && notificationItem.showtasknotification !== 0) {
            allowed = false;
            error = (notificationItem.referenceid || "") + " " + this.props.intl.formatMessage({ id: "BATCH_OPS.ERRORS.RECORD_NOT_DRAFT" });
        } else if (notificationItem.communicated) {
            allowed = false;
            error = (notificationItem.referenceid || "") + " " + this.props.intl.formatMessage({ id: "BATCH_OPS.ERRORS.RECORD_NOT_DRAFT" });
        }
        return { allowed, error }
    }
    validateDeactivate = (recordItem) => {
        if (this.props.validateDeactivate) {
            return this.props.validateDeactivate(recordItem);
        }
        let allowed = true;
        let error = "";

        return { allowed, error }
    }
    validateActivate = (recordItem) => {
        if (this.props.validateActivate) {
            return this.props.validateActivate(recordItem);
        }
        let allowed = true;
        let error = "";

        return { allowed, error }
    }
    toolbarTitleRender = () => {
        if (this.props.title) {
            return (
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    {
                        this.props.userProfile.accounttype === "System Owner" && this.props.workflowItem && (

                            <div style={{ marginRight: 8 }}>
                                <i id="workflowInfo" className="dx-icon dx-icon-info align-top ml-2" style={{ fontSize: '20px' }}></i>
                                <Popover
                                    target="#workflowInfo"
                                    showEvent="click"
                                    // hideEvent="mouseleave"
                                    position="right"
                                    width={500}
                                    showTitle={true}
                                    title={this.props.workflowItem?.id + " - " + this.props.workflowItem?.config?.description}
                                    maxHeight={700}
                                >
                                    <pre>{JSON.stringify(this.props.workflowItem, null, 2)}</pre>
                                </Popover>
                            </div>

                        )
                    }
                    <h3 style={{ fontFamily: SystemHelper.getThemeTextFont(), fontSize: '1.2rem', fontWeight: 500, color: '#48465b', padding: 0, margin: 0, lineHeight: 1.2 }} className="kt-portlet__head-title">{Common.CapitalFirstLetter(this.props.title)}</h3>
                </div>
            );
        }
        return null;

    }
    onRowPrepared = (e) => {
        e.rowElement.style.maxHeight = "50px";
    }
    navigateToCreate = () => {
        this.props.navigate(this.props.createPath);
    }

    renderIdColumn = (cellInfo) => {
        const calculateURL = cellInfo.component.columnOption('url', 'calculateCellValue');
        const url = calculateURL(cellInfo.data);
        return (
            <Link className='WrappedIdColumnWithPointerWithoutColor' to={url}>
                <strong className='WrappedIdColumnWithPointerWithoutColor' style={{ whiteSpace: 'normal' }}>
                    {cellInfo.value}
                </strong>
            </Link>
        );
    }
    // calculateIdCellValue = (rowData) => {
    //     return rowData.referenceid;
    // }
    // sortIdColumn = (rowData) => {
    //     return rowData.sequencenumber;
    // }


    generateUniqueGridName = () => {
        const name = this.props.name.replace(/\s/g, "");
        return process.env.REACT_APP_PRODUCT_KEY + "_XX" + name + "_" + this.props.version;
    }
    renderHtmlCell = (field, cellInfo) => {
        if (cellInfo.data[field]) {
            const cleanHTML = sanitizeHtml(cellInfo.data[field], { ...htmlSenitizeOptions });
            return (
                <div style={{ maxHeight: 100, overflow: 'hidden', textOverflow: 'ellipsis' }} dangerouslySetInnerHTML={{ __html: cleanHTML }} />
            );
        }
        else {
            return null
        }

    }
    calculateHtmlValue = (field, rowData) => {
        if (rowData[field]) {
            const cleanHTML = sanitizeHtml(rowData[field], { ...htmlSenitizeOptions });
            return Common.HtmlToString(cleanHTML);
        }
        else return null;

    }
    calculateTagValue = (field, rowData) => {
        if (rowData[field]) {
            return rowData[field].join(", ");;
        }
        else return null;

    }
    // onBatchEditClicked = () => {
    //     for (let index = 0; index < this.toolbarButtonRefs.length; index++) {
    //         const toolbarButtonRef = this.toolbarButtonRefs[index];
    //         if (toolbarButtonRef) { toolbarButtonRef.component.option("disabled", !this.state.batchEditing); }
    //     }
    //     if (this.state.batchEditing) {
    //         if (this.toolbarBatchEditButtonRef) {
    //             this.toolbarBatchEditButtonRef.component.option("text", "Edit Batch");
    //             this.toolbarBatchEditButtonRef.component.option("icon", "edit");
    //             this.toolbarBatchEditButtonRef.component.option("type", "normal");
    //             this.toolbarBatchEditButtonRef.component.option("stylingMode", "contained");
    //         }
    //         this.setState({ batchEditing: false })
    //     }
    //     else {
    //         if (this.toolbarBatchEditButtonRef) {
    //             this.toolbarBatchEditButtonRef.component.option("text", "Disable Editing");
    //             this.toolbarBatchEditButtonRef.component.option("icon", "close");
    //             this.toolbarBatchEditButtonRef.component.option("type", "default");
    //             this.toolbarBatchEditButtonRef.component.option("stylingMode", "outlined");
    //         }
    //         this.setState({ batchEditing: true })
    //     }
    // }
    onBatchSelectionChanged = ({ selectedRowKeys, component }) => {
        if (selectedRowKeys.length > 0 && selectedRowKeys.length <= batchCommunicateMaxCount) {
            if (this.refButtonBatchCommunicate) { this.refButtonBatchCommunicate.component.option("disabled", false); }
            if (this.refButtonBatchDelete) { this.refButtonBatchDelete.component.option("disabled", false); }
            if (this.refButtonBatchDeactivate) { this.refButtonBatchDeactivate.component.option("disabled", false); }
            if (this.refButtonBatchActivate) { this.refButtonBatchActivate.component.option("disabled", false); }

        } else {
            if (this.refButtonBatchCommunicate) { this.refButtonBatchCommunicate.component.option("disabled", true); }
            if (this.refButtonBatchDelete) { this.refButtonBatchDelete.component.option("disabled", true); }
            if (this.refButtonBatchDeactivate) { this.refButtonBatchDeactivate.component.option("disabled", true); }
            if (this.refButtonBatchActivate) { this.refButtonBatchActivate.component.option("disabled", true); }

        }
        if (selectedRowKeys.length > 0) {
            if (this.refButtonClearSelection) { this.refButtonClearSelection.component.option("disabled", false); }
        } else {
            if (this.refButtonClearSelection) { this.refButtonClearSelection.component.option("disabled", true); }
        }
        if (selectedRowKeys.length > batchCommunicateMaxCount) {
            this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: "GENERAL.USER_SELECTION_LIMIT_COUNT" }, { COUNT: batchCommunicateMaxCount }), { variant: "warning" });
        }
        component.refresh(true);
    }
    customSaveState = (state) => {
        localStorage.setItem(this.localStorageKey, JSON.stringify(state));
    }
    customLoadState = () => {
        const state = JSON.parse(localStorage.getItem(this.localStorageKey));
        //REMOVE ROW SELECTION
        if (state && state.selectedRowKeys) { delete state.selectedRowKeys };
        return state;
    }

    downloadImportTemplateClick = async () => {
        if (!this.formFields || this.formFields.length === 0) {
            this.formFields = await this.props.batchGetFormFieldsWithDownloadTemplateButton();
        }

        const workbook = MigrationHelper.getExcelTemplate(this.formFields, this.props.contract?.currency);

        const documentName = "Import_" + this.props.name.replace(/\s/g, "") + '.xlsx';
        // await workbook.xlsx.writeFile("first xls file");

        // https://github.com/exceljs/exceljs#writing-xlsx
        workbook.xlsx.writeBuffer()
            .then(function (buffer) {
                saveAs(new Blob([buffer], { type: 'application/octet-stream' }), documentName);
            })
            .catch(err => {

                // this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: 'ACTIONS.TOAST.IMPORTED' }, { COUNT: itemCount }), { variant: 'success', });

                console.log(err);
            });
    }
    importFileSelected = async (e) => {
        if (e.stopPropagation) { e.stopPropagation(); }
        if (e.preventDefault) { e.preventDefault(); }
        if (e.target && e.target.files && e.target.files.length > 0) {
            var file = e.target.files[0];
            if (file) {
                this.props.closeSnackbar();
                this.setState({ isBusy: true }, async () => {
                    try {
                        this.gridRef.current.instance().beginCustomLoading("Processing file...");
                        const dataCommonProperties = {
                            workflowid: this.props.workflowItem?.id,
                            notifyingparty: this.props.workflowItem?.notifyingParty,
                            replyingparty: this.props.workflowItem?.replyingParty,
                            quotingparty: this.props.workflowItem?.quotingParty,
                            quotereplyingparty: this.props.workflowItem?.quoteReplyingParty,
                            actioningparty: this.props.workflowItem?.actioningParty,
                        }

                        if (!this.formFields || this.formFields.length === 0) {
                            this.formFields = await this.props.batchGetFormFieldsWithDownloadTemplateButton();
                        }

                        const data = await MigrationHelper.processExcelFile(file, this.formFields, dataCommonProperties, this.props.customFields, this.props.contractUsers);
                        if (!data || data.length === 0) {
                            throw new Error("No data found!")
                        }
                        let activateDialog = CustomDialog({
                            title: this.props.intl.formatMessage({ id: 'BATCH_OPS.POPUP.IMPORT.TITLE' }, { COUNT: data.length }),
                            messageHtml: `<div style="max-width:60vw;">${this.props.intl.formatMessage({ id: 'BATCH_OPS.POPUP.IMPORT.MESSAGE' }, { COUNT: data.length })}</div>`,
                            buttons: [
                                {
                                    text: this.props.intl.formatMessage({ id: "GENERAL.FORMS.BUTTON_CANCEL" }),
                                    onClick: (e) => { return "CANCEL" }
                                },
                                {
                                    text: this.props.intl.formatMessage({ id: "GENERAL.FORMS.BUTTON_CREATE_DRAFT" }),
                                    type: "default",
                                    stylingMode: "outlined",
                                    onClick: (e) => { return "CONTINUE" }
                                }
                            ]
                        });
                        const result = await activateDialog.show();
                        if (result === "CONTINUE") {
                            const requestObj = {
                                contractid: this.props.contract?.contractid,
                                workflowid: this.props.workflowItem?.id,
                                data
                            }
                            const { data: batchResult } = await this.props.batchImportEndpoint(requestObj);

                            if (batchResult.successfulrecordcount > 0) {
                                this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: 'ACTIONS.TOAST.IMPORTED' }, { COUNT: batchResult.successfulrecordcount }), { variant: 'success', });
                            }
                            if (batchResult.error) {
                                console.log(batchResult.error)
                                this.props.enqueueSnackbar(batchResult.error, { variant: 'error', persist: true });
                            }

                            if (batchResult.successfulrecordcount === 0 && !batchResult.error) {
                                //NO IMPORT & NO ERROR
                                this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: 'ACTIONS.TOAST.IMPORTED_NONE' }), { variant: 'warning', });
                            }

                            this.props.onBatchRecordsUpdated?.();
                        }

                    } catch (err) {
                        this.props.enqueueSnackbar(err.toString(), { variant: 'error', persist: true });
                        console.log(err.toString())
                    }
                    finally {
                        if (this.fileImportInputRef.current) {
                            this.fileImportInputRef.current.value = null;
                        }
                        this.gridRef.current.instance().endCustomLoading();
                        this.setState({ isBusy: false })
                    }
                })

            }
        }
    }
    importExcelClicked = (e) => {
        if (this.fileImportInputRef.current) {
            this.fileImportInputRef.current.click();
        }
    }
    render() {
        if (!this.props.dataSource) {
            return null;
        }
        const gridSelection = this.gridRef?.current?.instance?.getSelectedRowKeys?.();
        let editingMode = "none";
        let hoverStateEnabled = this.props.hoverStateEnabled || false;
        let onSelectionChanged = null;
        if (this.dataGridProps.onSelectionChanged) {
            editingMode = "single"
            onSelectionChanged = this.dataGridProps.onSelectionChanged;
        }
        if (this.state.batchEditing) {
            editingMode = "multiple"
            onSelectionChanged = this.onBatchSelectionChanged;
            hoverStateEnabled = false;
        }
        return (
            <div style={{ width: '100%', height: '67vh' }}>
                <NavigationBlocker
                    when={(this.state.isBusy)}
                    message={this.props.intl.formatMessage({ id: 'GENERAL.FORMS.WARNING_UNSAVED' })}
                />
                <DataGrid
                    ref={this.gridRef}
                    disabled={this.state.isBusy}
                    rowHeight={50}
                    {...this.dataGridProps}
                    hoverStateEnabled={hoverStateEnabled}
                    rowAlternationEnabled={this.state.batchEditing ? true : false}
                    dataSource={this.props.dataSource}
                    selection={{
                        mode: editingMode,
                        selectAllMode: "allPages",
                        showCheckBoxesMode: "always"
                    }}
                    onSelectionChanged={onSelectionChanged}
                    onRowPrepared = {this.state.batchEditing ? null : this.dataGridProps.onRowPrepared}
                >
                    <HeaderFilter visible={true} />
                    <FilterRow applyFilter="auto" visible={true} />
                    <FilterPanel visible={true} />
                    <ColumnChooser mode="select" enabled={true} search={{ enabled: true }}  >
                        {/* <ColumnChooserSearch enabled={true} timeout={800} /> */}
                    </ColumnChooser>
                    <ColumnFixing enabled={true} />
                    <StateStoring
                        enabled={true}
                        type="custom"
                        // storageKey={this.generateUniqueGridName()}
                        customSave={this.customSaveState}
                        customLoad={this.customLoadState}
                    />
                    <Export enabled={true} fileName={this.props.name} />
                    <SearchPanel visible={true} highlightCaseSensitive={false} defaultText="" />
                    {
                        this.columns.map((columnItem, index) => (
                            <Column cssClass="WrappedColumnClass" key={index} {...columnItem} />
                        ))
                    }
                    <Template name="toolbarTitle" render={this.toolbarTitleRender} />
                    <Scrolling mode="virtual" showScrollbar={true} useNative={true} columnRenderingMode="virtual" rowRenderingMode="virtual" />
                    <Toolbar>
                        <ToolbarItem location="before"
                            locateInMenu="never"
                            template="toolbarTitle"
                        />
                        {
                            (this.additionalToolbarItems || []).map((item, index) => (
                                <ToolbarItem
                                    key={"CustomToolbarItem" + index.toString()}
                                    {...item}
                                    disabled={this.state.batchEditing}
                                />
                            ))
                        }
                        {this.batchOperationsEnabled && (
                            <ToolbarItem
                                location="after"
                                locateInMenu="always"
                                widget="dxButton"
                                visible={this.batchOperationsEnabled}
                                options={
                                    {
                                        onInitialized: (e) => { this.toolbarBatchEditButtonRef = e; },
                                        icon: this.state.batchEditing ? "close" : "edit",
                                        onClick: () => {
                                            this.gridRef.current.instance().clearSelection();
                                            this.props.closeSnackbar();
                                            if (!this.state.batchEditing && this.batchUnsupportedCustomFieldWarning) {
                                                this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: "BATCH_OPS.WARNING.UNSUPPORTED_CF" }), { variant: "warning" });
                                            }
                                            this.setState({ batchEditing: !this.state.batchEditing });
                                        },
                                        text: this.state.batchEditing ? this.props.intl.formatMessage({ id: "BATCH_OPS.BUTTON.DISABLE_EDITING" }) : this.props.intl.formatMessage({ id: "BATCH_OPS.BUTTON.EDIT_BATCH" }),
                                        type: this.state.batchEditing ? "default" : "normal",
                                        stylingMode: this.state.batchEditing ? "outlined" : "contained",
                                    }
                                }
                            />
                        )}
                        {(this.batchOperationsEnabled && this.state.batchEditing && this.props.batchCommunicateEndpoint) && (
                            <ToolbarItem
                                location="after"
                                locateInMenu="auto"
                                widget="dxButton"
                                visible={this.state.batchEditing}
                                options={{
                                    onInitialized: (e) => { this.refButtonBatchCommunicate = e; },
                                    icon: "increaseindent",
                                    text: this.props.intl.formatMessage({ id: "ACTIONS.BUTTON.COMMUNICATE" }),
                                    disabled: !gridSelection?.length,
                                    onClick: this.batchCommunicateSelectedClick,
                                    type: "success",
                                    stylingMode: "outlined",
                                }}
                            />
                        )}
                        {(this.batchOperationsEnabled && this.state.batchEditing && this.props.batchDeleteEndpoint) && (
                            <ToolbarItem
                                location="after"
                                locateInMenu="auto"
                                widget="dxButton"
                                visible={this.state.batchEditing}
                                options={{
                                    onInitialized: (e) => { this.refButtonBatchDelete = e; },
                                    icon: "trash",
                                    text: this.props.intl.formatMessage({ id: "ACTIONS.BUTTON.DELETE_DRAFTS" }),
                                    disabled: !gridSelection?.length,
                                    onClick: this.deleteSelectedClick,
                                    type: "danger",
                                    stylingMode: "outlined",
                                }}
                            />
                        )}
                        {(this.batchOperationsEnabled && this.state.batchEditing && this.props.batchDeactivateEndpoint) && (
                            <ToolbarItem
                                location="after"
                                locateInMenu="auto"
                                widget="dxButton"
                                visible={this.state.batchEditing}
                                options={{
                                    onInitialized: (e) => { this.refButtonBatchDeactivate = e; },
                                    icon: "deleterow",
                                    text: this.props.intl.formatMessage({ id: "ACTIONS.BUTTON.DEACTIVATE" }),
                                    disabled: !gridSelection?.length,
                                    onClick: this.deactivateSelectedClick,
                                    type: "warning",
                                    stylingMode: "outlined",
                                    elementAttr: { class: "biWarningButton" },
                                }}
                            />
                        )}
                        {(this.batchOperationsEnabled && this.state.batchEditing && this.props.batchActivateEndpoint) && (
                            <ToolbarItem
                                location="after"
                                locateInMenu="auto"
                                widget="dxButton"
                                visible={this.state.batchEditing}
                                options={{
                                    onInitialized: (e) => { this.refButtonBatchActivate = e; },
                                    icon: "redo",
                                    text: this.props.intl.formatMessage({ id: "ACTIONS.BUTTON.ACTIVATE" }),
                                    disabled: !gridSelection?.length,
                                    onClick: this.activateSelectedClick,
                                    type: "success",
                                    stylingMode: "outlined",
                                }}
                            />
                        )}

                        {(this.batchOperationsEnabled && this.state.batchEditing && (this.props.batchCommunicateEndpoint || this.props.batchDeleteEndpoint || this.props.batchDeactivateEndpoint || this.props.batchActivateEndpoint)) && (
                            <ToolbarItem
                                location="after"
                                locateInMenu="auto"
                                widget="dxButton"
                                visible={this.state.batchEditing}
                                options={{
                                    onInitialized: (e) => { this.refButtonClearSelection = e; },
                                    icon: "clear",
                                    text: this.props.intl.formatMessage({ id: "ACTIONS.BUTTON.CLEAR_SELECTION" }),
                                    disabled: !gridSelection?.length,
                                    onClick: () => this.gridRef.current.instance().clearSelection()
                                }}
                            />
                        )}
                        {(this.batchOperationsEnabled && this.state.batchEditing) && (
                            <ToolbarItem
                                location="after"
                                locateInMenu="auto"
                                widget="dxButton"
                                visible={this.batchOperationsEnabled}
                                options={{
                                    icon: "import",
                                    text: this.props.intl.formatMessage({ id: "ACTIONS.BUTTON.IMPORT_FROM_EXCEL" }),
                                    onClick: this.importExcelClicked,
                                }}
                            />
                        )}
                        {(this.batchOperationsEnabled && this.state.batchEditing) && (
                            <ToolbarItem
                                location="after"
                                locateInMenu="auto"
                                widget="dxButton"
                                visible={this.batchOperationsEnabled}
                                options={
                                    {
                                        onInitialized: (e) => { this.toolbarBatchButtonRefs.push(e); },
                                        icon: "download",
                                        onClick: this.downloadImportTemplateClick,
                                        text: "Download Template",
                                    }
                                }
                            />
                        )}
                        {
                            (this.props.createPath) && (
                                <ToolbarItem location="after"
                                    locateInMenu="auto"
                                    widget="dxButton"
                                    disabled={this.state.batchEditing}
                                    options={{
                                        onInitialized: (e) => { this.toolbarButtonRefs.push(e); },
                                        icon: "plus",
                                        text: this.props.intl.formatMessage({ id: "GENERAL.FORMS.BUTTON_CREATE_NEW" }),
                                        onClick: this.navigateToCreate
                                    }}
                                />
                            )
                        }

                        <ToolbarItem location="after"
                            locateInMenu="auto"
                            name="exportButton"
                            disabled={this.state.batchEditing}
                            options={
                                {
                                    onInitialized: (e) => { this.toolbarButtonRefs.push(e); },
                                }
                            }
                        />


                        <ToolbarItem location="after"
                            locateInMenu="auto"
                            name="columnChooserButton"
                            disabled={this.state.batchEditing}
                            options={{
                                onInitialized: (e) => { this.toolbarButtonRefs.push(e); },
                            }}
                        />


                        <ToolbarItem location="after"
                            locateInMenu="auto"
                            name="searchPanel"
                            disabled={this.state.batchEditing}
                            options={{
                                onInitialized: (e) => { this.toolbarButtonRefs.push(e); },
                            }}
                        />


                    </Toolbar>
                    <Summary>
                        <TotalItem column={0} summaryType="count" />
                    </Summary>
                </DataGrid>
                <input type='file' id='importFile' accept='.xlsx' ref={this.fileImportInputRef} style={{ display: 'none' }} onChange={this.importFileSelected} />
                <DataGridBaseBatchComModal
                    visible={this.state.showCommunicateModal}
                    selectedItemCount={gridSelection?.length}
                    onApproved={this.batchCommunicatApprovedClick}
                    onCancel={() => this.setState({ showCommunicateModal: false })}
                    workflowItem={this.props.workflowItem}
                />

            </div>

        );
    }

}
DataGridBase.propTypes = {
    //REQUIRED
    name: PropTypes.string.isRequired,
    columns: PropTypes.array.isRequired,
    keyExpr: PropTypes.string.isRequired,
    //OPTIONAL
    dataSource: PropTypes.array,
    title: PropTypes.string,
    version: PropTypes.string,
    referenceIDPrefix: PropTypes.string,
    workflowItem: PropTypes.object,
    hoverStateEnabled: PropTypes.bool,
    rowAlternationEnabled: PropTypes.bool,

    gridRef: PropTypes.object,
    additionalToolbarItems: PropTypes.array,
    isContract: PropTypes.bool,
    onSelectionChanged: PropTypes.func,
    repaintAfterMounted: PropTypes.bool,
    createPath: PropTypes.string,

    //BATCH
    batchOperations: PropTypes.bool,
    batchImportEndpoint: PropTypes.func,
    batchDeleteEndpoint: PropTypes.func,
    batchDeactivateEndpoint: PropTypes.func,
    batchActivateEndpoint: PropTypes.func,
    validateActivate: PropTypes.func,
    validateDeactivate: PropTypes.func,
    batchCommunicateEndpoint: PropTypes.func,
    onBatchRecordsUpdated: PropTypes.func,
    batchGetFormFieldsWithDownloadTemplateButton: PropTypes.func,


    batchFormFields: function (props, propName, componentName) {
        if (props['batchOperations'] === true) {
            if (
                (props[propName] == undefined || !Array.isArray(props[propName])) &&
                !props['batchGetFormFieldsWithDownloadTemplateButton']
            ) {
                return new Error('Please provide batchFormFields array or batchGetFormFieldsWithDownloadTemplateButton function!');
            }

        }
    },

    //HOC
    intl: PropTypes.object.isRequired,
    userProfile: PropTypes.object.isRequired,
    navigate: PropTypes.func.isRequired,
    enqueueSnackbar: PropTypes.func.isRequired,
    contract: PropTypes.object,

};
const mapStateToProps = store => ({
    userProfile: store.auth.userProfile,
    contract: store.contract.contract,
    contractUsers: store.contract.users
});

export default withSnackbar(injectIntl(withRouter(connect(mapStateToProps)(DataGridBase))));